import script from "./TradePassportJobs.vue?vue&type=script&lang=ts&setup=true"
export * from "./TradePassportJobs.vue?vue&type=script&lang=ts&setup=true"

import "./TradePassportJobs.vue?vue&type=style&index=0&id=2384d700&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2384d700"]])

export default __exports__